import Layout from "@/components/Layout"
import TutorialSlider from "@/components/TutorialSlider"
import TutorialSliderData from "@/components/TutorialSlider/data.json"
import { mapDispatchToProps } from "@/lib/withReduxStore"
import { NextPage } from "next"
import Head from "next/head"
import React from "react"
import { connect } from "react-redux"

interface PageProps {}

const Tutorial: NextPage<PageProps> = (props) => {
  return (
    <>
      <Head>
        <title>Black Mirror - Tutorial</title>
        <meta name="description" content="meta" />
      </Head>

      <Layout>
        <TutorialSlider {...TutorialSliderData} />
      </Layout>
    </>
  )
}

Tutorial.getInitialProps = async ({
  reduxStore,
  query
}: any): Promise<PageProps> => {
  return query
}

export default connect(
  null,
  mapDispatchToProps
)(Tutorial)
